import React from 'react';
import { roles } from '@nxsys/store/constants';

const SettingsPage = React.lazy(
  () => import('../../../modules/settings'),
);

export const settingsConfig = [
  {
    permittedRole: [roles.admin],
    path: '/settings',
    element: <SettingsPage />,
  },
];
